import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import PrinterSettingsOptions from "./PrinterSettingsOptions";
import {
  getPrinterSettings,
  printerSettingsInitData,
  updatePrinterSettings,
  validatePrinterSettingsInputs,
} from "../../services/settings-service";
import useUserStore from "../../stores/store";
import useGeneralStore from "../../stores/useGeneralStore";
import PrinterSettingsCashDrawer from "./PrinterSettingsCashDrawer";

const { Panel } = Collapse;

/**
 * This component should be used other places and everything should be done inside it or its child component but recommended not pass any data to its invoked page or component
 *
 * @param {*} param0
 * @returns
 */
export default function PrinterSettingsWrapper({}) {
  const { restaurantId, user, setNetworkCall, showNotification } = useUserStore();
  const {
    isDeviceUsedAsAutoPrintInvoice,
    isDeviceUsedAsAutoPrintKitchenSlip,
    setIsDeviceUsedAsAutoPrintInvoice,
    setIsDeviceUsedAsAutoPrintKitchenSlip,
  } = useGeneralStore();

  const [printerSettings, setPrinterSettings] = useState(printerSettingsInitData);
  const [cashDrawerSettings, setCashDrawerSettings] = useState(printerSettingsInitData);

  const onChangeUseForPrinting = (purpose, e) => {
    console.log("---onChangeUseForPrinting---", { purpose, checked: e.target.checked });
    if (purpose === "INVOICE") {
      setIsDeviceUsedAsAutoPrintInvoice(e.target.checked);
    } else {
      setIsDeviceUsedAsAutoPrintKitchenSlip(e.target.checked);
    }
  };

  const onHandleSave = async (isInvoice, settingsData) => {
    try {
      const reqBody = {
        ...settingsData,
        restaurantId,
        context: isInvoice ? "INVOICE" : "KITCHEN_SLIP",
      };

      console.log("------onHandleSave--------", { isInvoice, reqBody });

      const errorMsg = validatePrinterSettingsInputs(reqBody);

      if (errorMsg) {
        showNotification(errorMsg);
        return;
      }

      setNetworkCall(true);

      const result = await updatePrinterSettings(reqBody, user.token.token);

      if (result.success && isInvoice) {
        setCashDrawerSettings(settingsData);
      }

      showNotification(result.msg, !result.success);
    } catch (error) {
      console.error("Failed to save data. Error:", error);
      showNotification("Failed to save data.");
    } finally {
      setNetworkCall(false);
    }
  };

  const onHandleCashDrawerSave = (cashDrawerCommand) => {
    console.log("----------onHandleCashDrawerSave----called----", {cashDrawerCommand});

    onHandleSave(true, {...cashDrawerSettings, cashDrawerCommand})
  };

  useEffect(() => {
    if (restaurantId) {
      (async () => {
        try {
          const retResult = await getPrinterSettings({ restaurantId }, user.token.token);

          if (!retResult.success) {
            showNotification(retResult.msg);
            return;
          }

          const updatedSettings = { ...retResult.data, isServerDataLoaded: true };

          setPrinterSettings(updatedSettings);
          setCashDrawerSettings(updatedSettings.printerSettingsInvoice);
        } catch (err) {
          console.log("********Error while getting printer settings**", err);
          showNotification(err.message());
        } finally {
          setNetworkCall(false);
        }
      })();
    }
  }, [restaurantId]);

  return (
    <div className="">
      <Collapse accordion>
        <Panel
          header={
            <span className="font-semibold">
              <PrinterOutlined style={{ marginRight: 8, color: "#1890ff" }} />
              Invoice Printer
            </span>
          }
          key="1"
        >
          <PrinterSettingsOptions
            isInvoice={true}
            settingsData={printerSettings.printerSettingsInvoice}
            isServerDataLoaded={printerSettings.isServerDataLoaded}
            onHandleSave={onHandleSave}
            isUseForAutoPrint={isDeviceUsedAsAutoPrintInvoice}
            onChangeUseForPrinting={onChangeUseForPrinting}
          />
        </Panel>
        <Panel
          header={
            <span className="font-semibold">
              <PrinterOutlined style={{ marginRight: 8, color: "#1890ff" }} />
              Kitchen Slip Printer
            </span>
          }
          key="2"
        >
          <PrinterSettingsOptions
            isInvoice={false}
            settingsData={printerSettings.printerSettingsKitchenSlip}
            onHandleSave={onHandleSave}
            isServerDataLoaded={printerSettings.isServerDataLoaded}
            isUseForAutoPrint={isDeviceUsedAsAutoPrintKitchenSlip}
            onChangeUseForPrinting={onChangeUseForPrinting}
          />
        </Panel>
        <Panel
          header={
            <span className="font-semibold">
              <PrinterOutlined style={{ marginRight: 8, color: "#1890ff" }} />
              Cash Drawer
            </span>
          }
          key="3"
        >
          <PrinterSettingsCashDrawer
            settingsData={cashDrawerSettings}
            onHandleSave={onHandleCashDrawerSave}
            cashDrawerCommands={printerSettings.cashDrawerCommands}
          />
        </Panel>
      </Collapse>
    </div>
  );
}
